import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { store } from "./app/store";

import UserApp from "./pages/users/UserApp";
import AdminApp from "./pages/admin/AdminApp";
import AdminLogin from "./pages/admin/auth/Login";
import { ToastContainer } from "react-toastify";


const root = ReactDOM.createRoot(document.getElementById("root"));


root.render(
  <Provider store={store}>
    <BrowserRouter>
    <ToastContainer  />
      <Routes>
         
        {/* ✅ ADMIN LOGIN (PUBLIC) */}
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* ✅ ADMIN (PROTECTED) */}
        <Route path="/admin/*" element={<AdminApp />} />

        {/* USER ROUTES - Keep at the end */}
        <Route path="/*" element={<UserApp />} />
      </Routes>
    </BrowserRouter>
  </Provider>
);
